import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../context/I18nContext';
import LanguageSwitcher from '../components/LanguageSwitcher';

const Welcome = () => {
    const { authenticated } = useAuth();
    const { t } = useI18n(['common', 'welcome']);

    return (
        <div className="min-h-screen flex items-center justify-center bg-linear-to-br from-blue-50 to-gray-100 px-4">
            {/* Language Switcher in top right corner */}
            <div className="absolute top-4 right-4">
                <LanguageSwitcher />
            </div>
            
            <div className="max-w-4xl w-full text-center">
                <div className="bg-white rounded-lg shadow-2xl p-12">
                    <div className="mb-8">
                        <svg className="w-24 h-24 mx-auto text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                        </svg>
                    </div>
                    
                    <h1 className="text-5xl font-bold text-gray-900 mb-4">
                        {t('title', { ns: 'welcome' }) || 'Welcome to OA System'}
                    </h1>
                    
                    <p className="text-xl text-gray-600 mb-8">
                        {t('description', { ns: 'welcome' }) || 'You submit the travel request and entertainment expense reimbursement here.'}
                    </p>
                    
                    <div className="space-y-4">
                        <Link
                            to="/login"
                            className="inline-block w-full max-w-md bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-md transition-colors shadow-lg"
                        >
                            {!authenticated ? t('signIn', { ns: 'welcome' }) || 'Sign In' : t('signInAlready', { ns: 'welcome' }) || 'Already Signed In'}
                        </Link>
                        
                        <p className="text-sm text-gray-500">
                            {!authenticated ? t('pleaseLogin', { ns: 'welcome' }) || 'Please login to access the system.' : t('alreadyLoggedIn', { ns: 'welcome' }) || 'You are already logged in.'}
                        </p>
                    </div>
                </div>
                
                <div className="mt-8 text-gray-600">
                    <p className="text-sm">
                        © {new Date().getFullYear()} Luminus. {t('copyright', { ns: 'welcome' }) || 'All rights reserved.'}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Welcome;
